import { Row } from 'antd';
import Layout from 'antd/lib/layout/layout';
import React, { useEffect, useState } from 'react';
import WorkPlaceData from '../../../Assets/JsonData/WorkPlaceData.json'
import SinglePlace from './SinglePlace';

const WorkingSpace = () => {

    console.log(WorkPlaceData);

    const [workPlaces, setWorkPlaces] = useState(WorkPlaceData)

    useEffect(() => {
        setWorkPlaces(workPlaces)
    }, [workPlaces])

    return (
        <Layout>
            <Row justify="center" style={{padding:'4rem 0'}}>
                {workPlaces && workPlaces.map(workPlace => <SinglePlace workPlace={workPlace} key={workPlace.id} />)}
            </Row>
        </Layout>
    );
};

export default WorkingSpace;